// NOTE: There are same fuctions in results/Resource.jsx!!!

import ClipboardJS from "clipboard";
const isDev = window.location.hostname.includes("localhost");

// COPY
const copyBtns = document.querySelectorAll("[data-clipboard-text]");
if (copyBtns) {
  copyBtns.forEach((btn) => {
    const button = new ClipboardJS(btn);

    button.on("success", function (e: any) {
      e.clearSelection();
      if (!isDev) {
        gtag("event", "copy", {});
      }

      btn.textContent = "Text Copied!";
      setTimeout(() => {
        btn.textContent = "Copy Text";
      }, 2000);
    });
  });
}

// PRINT
const printBtns = document.querySelectorAll("[data-print]");
if (printBtns) {
  printBtns.forEach((btn) => {
    const printTarget = btn.getAttribute("data-print");

    btn.addEventListener("click", () => {
      if (!isDev) {
        gtag("event", "print", {});
      }

      if (printTarget === "all") {
        // INFO: For Your List and singe result/agency pages
        // override the single result before & after print
        window.onbeforeprint = () => {};
        window.onafterprint = () => {};
        window.print();
      } else {
        // INFO: For result card on agency and your list pages
        const targetElement = document.querySelector(`[data-id="${printTarget}"]`);
        const hiddenClassNames = [".services-heading", ".agency-main", ".section.header"];
        const beforePrint = () => {
          targetElement && targetElement.classList.add("print-only");

          hiddenClassNames.forEach((className) => {
            const element = document.querySelector(className);
            if (element) {
              element.classList.add("hidden");
            }
          });
        };

        const afterPrint = () => {
          targetElement && targetElement.classList.remove("print-only");

          hiddenClassNames.forEach((className) => {
            const element = document.querySelector(className);
            if (element) {
              element.classList.remove("hidden");
            }
          });
        };

        window.onbeforeprint = () => beforePrint();
        window.onafterprint = () => afterPrint();
        window.print();
      }
    });
  });
}

// SHARE
const copyListBtn = document.querySelector("#copyList");
const shareBtns = document.querySelectorAll("[data-share]");
if (shareBtns) {
  shareBtns.forEach((btn) => {
    if (!navigator.canShare) {
      btn.classList.add("hidden");
    } else if (navigator.canShare && btn) {
      btn.addEventListener("click", async () => {
        const shareValue = (btn as HTMLElement).getAttribute("data-share");
        const isList = shareValue === "list";
        const shareUrl = isList
          ? (copyListBtn as HTMLElement).getAttribute("data-clipboard-text")
          : shareValue;
        const shareTxt = isList
          ? "Check out the list of resources: "
          : "I found this resource on 211 British Columbia: ";
        const shareData = {
          title: isList
            ? "My list of selected resources from bc.211.ca"
            : "Resource from bc.211.ca",
          text: shareTxt + (shareUrl ? shareUrl : ""),
          url: shareUrl ? shareUrl : window.location.href,
        };

        if (!isDev) {
          gtag("event", "share", {});
        }

        if (shareData && navigator.canShare(shareData)) {
          try {
            await navigator.share(shareData);
          } catch (err) {
            console.error("There was an error trying to share this content", err);
          }
        }
      });
    }
  });
}
